<template>
  <div>
    <h1>Personal - Συνδρομές</h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Entries",

  data: () => ({}),

  computed: {
    ...mapGetters(["loading", "currencies"]),
  },

  methods: {},
};
</script>
